import { render } from "./Contact.vue?vue&type=template&id=9e61f68e&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=9e61f68e&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\ofira-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e61f68e"]])

export default __exports__